webpackJsonp([26],{

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(770),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_graphql__ = __webpack_require__(139);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      lots: ['1', '2', '3', '4'],
      dataLot: '',
      dataLamina: '',
      dateFrom: '',
      dateTo: '',
      snackbar: false,
      snackBarText: '',
      snackbarColor: 'red',
      timeOut: 5000,
      User: {}
    };
  },

  apollo: {
    User: {
      query: __WEBPACK_IMPORTED_MODULE_0__constants_graphql__["e" /* USER_QUERY */],
      variables: function variables() {
        return {
          id: this.$store.getters.user.id
        };
      }
    }
  },
  props: {
    deviceId: {
      type: String
    },
    device: {
      type: Object
    },
    irrigationOrderDialog: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    crops: function crops() {
      if (!this.device.Crops) {
        return ['Lote 1'];
      }
      return this.device.Crops.map(function (item) {
        return item.name;
      });
    },
    lastEventDate: function lastEventDate() {
      if (this.device.Event) {
        return new Date(this.device.Event.dateTime);
      } else {
        return null;
      }
    }
  },
  methods: {
    sendWhatsapp: function sendWhatsapp() {
      if (!this.dateFrom.length || !this.dateTo.length || !this.dataLamina.length || !this.dataLot.length) {
        this.snackbar = true;
        this.snackBarText = 'Por favor, completar los datos';
        return;
      }
      if (this.dateFrom > this.dateTo) {
        this.snackbar = true;
        this.snackBarText = 'Por favor, verificar fechas';
        return;
      }
      if (this.dataLamina > 50 || this.dataLamina < 1) {
        this.snackbar = true;
        this.snackBarText = 'Por favor, verificar lámina';
        return;
      }
      var currentDate = new Date();
      var userName = this.User.name;
      var irrigationText = '*Orden de Riego* %0A ' + this.dataLamina + 'mm para ser regados entre ' + this.dateFrom.substr(8, 2) + '/' + this.dateFrom.substr(5, 2) + ' y ' + this.dateTo.substr(8, 2) + '/' + this.dateTo.substr(5, 2) + ', en el lote ' + this.dataLot + ' %0A Saludos, ' + userName + ' %0A %0A Fecha de emision: ' + currentDate.getDate() + '/' + (currentDate.getMonth() + 1) + '/' + currentDate.getFullYear();
      var variables = {
        name: '',
        dateTime: currentDate.toISOString(),
        note: this.dataLamina + 'mm - Lote ' + this.dataLot + ' <br> ' + this.dateFrom.substr(8, 2) + '/' + this.dateFrom.substr(5, 2) + ' - ' + this.dateTo.substr(8, 2) + '/' + this.dateTo.substr(5, 2) + ' <br> ' + userName,
        deviceId: parseInt(this.deviceId)
      };
      this.$store.dispatch('uploadIrrigationOrder', {
        variables: variables,
        comesFromStore: false,
        key: null
      });
      this.$emit('update:irrigationOrderDialog', false);
      mixpanel.track('Create irrigation order', {
        'id': this.deviceId,
        'text': irrigationText
      });
      window.open('https://api.whatsapp.com/send?text=' + irrigationText, '_blank');
    }
  }
});

/***/ }),

/***/ 770:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600"
    },
    model: {
      value: (_vm.irrigationOrderDialog),
      callback: function($$v) {
        _vm.irrigationOrderDialog = $$v
      },
      expression: "irrigationOrderDialog"
    }
  }, [_c('app-snackbar', {
    attrs: {
      "text": _vm.snackBarText,
      "show": _vm.snackbar,
      "color": _vm.snackbarColor,
      "timeOut": _vm.timeOut
    },
    on: {
      "update:show": function($event) {
        _vm.snackbar = $event
      }
    }
  }), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('h2', [_vm._v("ORDEN DE RIEGO")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-select', {
    attrs: {
      "items": _vm.crops,
      "label": "Lote"
    },
    model: {
      value: (_vm.dataLot),
      callback: function($$v) {
        _vm.dataLot = $$v
      },
      expression: "dataLot"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "step": "any",
      "type": "number",
      "min": "1",
      "max": "50",
      "label": "Lámina"
    },
    model: {
      value: (_vm.dataLamina),
      callback: function($$v) {
        _vm.dataLamina = $$v
      },
      expression: "dataLamina"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex padding-col",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex padding-subdate",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Desde",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.dateFrom),
            callback: function($$v) {
              _vm.dateFrom = $$v
            },
            expression: "dateFrom"
          }
        }, on))]
      }
    }])
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": new Date(new Date().setDate(new Date().getDate())).toISOString().substr(0, 10)
    },
    model: {
      value: (_vm.dateFrom),
      callback: function($$v) {
        _vm.dateFrom = $$v
      },
      expression: "dateFrom"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex padding-subdate",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Hasta",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.dateTo),
            callback: function($$v) {
              _vm.dateTo = $$v
            },
            expression: "dateTo"
          }
        }, on))]
      }
    }])
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": new Date(new Date().setDate(new Date().getDate())).toISOString().substr(0, 10)
    },
    model: {
      value: (_vm.dateTo),
      callback: function($$v) {
        _vm.dateTo = $$v
      },
      expression: "dateTo"
    }
  })], 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('update:irrigationOrderDialog', false)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.sendWhatsapp()
      }
    }
  }, [_vm._v("Emitir")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/26.98010ca354c577f4251d.js